// extracted by mini-css-extract-plugin
export default {"container":"orderDetails_container__B4dh-","title":"orderDetails_title__9ymKZ","type":"orderDetails_type__nPh-X"};